module.exports = __webpack_public_path__ + "static/media/arrow-results.c0a5af2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/arrow-results.svg
// module id = 664
// module chunks = 0